import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { FC } from 'react';

interface TableEmptyProps {
  message?: string;
}

export const TableEmpty: FC<TableEmptyProps> = ({
  message = 'No data available'
}) => {
  return (
    // Centered content with more vertical padding and slightly muted text
    <div className="w-full py-16 flex flex-col items-center justify-center text-center text-gray-400">
      {/* Larger, more relevant icon with adjusted margin */}
      <InformationCircleIcon className="h-24 w-24 mb-4 text-gray-500" />
      {/* Larger, medium-weight text for better readability */}
      <p className="text-lg font-medium">{message}</p>
      {/* Optional: Add a subtle hint or suggestion */}
      <p className="text-sm mt-2 text-gray-500">Try adjusting your filters or search criteria.</p>
    </div>
  );
};